import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import rulePopout from 'components/triggers/RulePopout';
import TopicCoverageSelection from './TopicCoverageSelection';
import CheckIcon from '@material-ui/icons/Check';
import FlatButton from 'components/pure/utils/FlatButton';
import {KeywordTopicPhrase, TopicCoverageCondition, SpeakerCondition} from 'records/CallTrigger';
import FilterWordsStore from 'stores/triggers/FilterWordsStore';
import FilterWordsActions from 'actions/triggers/FilterWordsActions';

class TopicCoverageSelectionContainer extends React.Component {
  constructor(props) {
    super(props);

    this.canSave = this.canSave.bind(this);
    this.conditionChange = this.conditionChange.bind(this);

    this.state = {
      condition: new TopicCoverageCondition({
        speakerType: SpeakerCondition.EXTERNAL,
        negated: false,
        keywordTopicPhrase: new KeywordTopicPhrase(),
      }),
    };
  }

  static getStores() {
    return [FilterWordsStore];
  }

  static getPropsFromStores() {
    return {
      filterWords: FilterWordsStore.getState().filterWords,
    };
  }

  canSave() {
    const {condition} = this.state;
    return condition.ready();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.condition) {
      this.setState({
        condition: nextProps.condition,
      });
    }
  }

  componentDidMount() {
    FilterWordsActions.fetchAll();
  }

  conditionChange(condition) {
    // prevent dragging sliders from causing a clickout of the popout
    this.props.blockClickOutTimeout();
    this.setState({
      condition,
    });
    condition.range !== undefined &&
      this.props.updateSelection &&
      this.props.updateSelection(condition);
  }

  render() {
    const canSave = this.canSave();
    return (
      <div className="rule-select-popup">
        <TopicCoverageSelection
          {...this.props}
          {...this.state}
          conditionChange={this.conditionChange}
          topicKeywordChange={this.topicKeywordChange}
          locationTypeChange={this.locationTypeChange}
        />
        <div className="selection-buttons">
          <button
            className={canSave ? 'save' : 'save disabled'}
            disabled={!canSave}
            onClick={() => this.props.saveSelection(this.state.condition)}>
            <CheckIcon htmlColor={canSave ? 'white' : 'gray'} />
          </button>
          <FlatButton onClick={() => this.props.closeRequest('cancel')}>Cancel</FlatButton>
        </div>
      </div>
    );
  }
}

export default rulePopout(connectToStores(TopicCoverageSelectionContainer));
